import DocumentViewerContainer from './documentViewerContainer';
export default DocumentViewerContainer;
